module.exports = __webpack_public_path__ + "img/favourites.d2675a58.png";